/* src/modules/interviews/action_types.js */

export const addScheduleTypes = [
  'ADD_SCHEDULE',
  'ADD_SCHEDULE_SUCCESS',
  'ADD_SCHEDULE_FAIL',
];

export const updateTimeblockTypes = [
  'UPDATE_TIMEBLOCK',
  'UPDATE_TIMEBLOCK_SUCCESS',
  'UPDATE_TIMEBLOCK_FAIL',
];

export const removeTimeblockTypes = [
  'REMOVE_TIMEBLOCK',
  'REMOVE_TIMEBLOCK_SUCCESS',
  'REMOVE_TIMEBLOCK_FAIL',
];

export const updateScheduleTypes = [
  'UPDATE_SCHEDULE',
  'UPDATE_SCHEDULE_SUCCESS',
  'UPDATE_SCHEDULE_FAIL',
];

export const removeScheduleTypes = [
  'REMOVE_SCHEDULE',
  'REMOVE_SCHEDULE_SUCCESS',
  'REMOVE_SCHEDULE_FAIL',
];

export const fetchScheduleTypes = [
  'FETCH_SCHEDULE',
  'FETCH_SCHEDULE_SUCCESS',
  'FETCH_SCHEDULE_FAIL',
];

export const fetchInterviewLocationsTypes = [
  'FETCH_INTERVIEW_LOCATIONS',
  'FETCH_INTERVIEW_LOCATIONS_SUCCESS',
  'FETCH_INTERVIEW_LOCATIONS_FAIL',
];

export const fetchInterviewsTypes = [
  'FETCH_INTERVIEWS',
  'FETCH_INTERVIEWS_SUCCESS',
  'FETCH_INTERVIEWS_FAIL',
];

export const confirmInterviewTypes = [
  'CONFIRM_INTERVIEW',
  'CONFIRM_INTERVIEW_SUCCESS',
  'CONFIRM_INTERVIEW_FAIL',
];

export const declineInterviewTypes = [
  'DECLINE_INTERVIEW',
  'DECLINE_INTERVIEW_SUCCESS',
  'DECLINE_INTERVIEW_FAIL',
];

export const fetchApplicantTypes = [
  'FETCH_APPLICANT',
  'FETCH_APPLICANT_SUCCESS',
  'FETCH_APPLICANT_FAIL',
];

export const fetchInterviewQuestionsTypes = [
  'FETCH_INTERVIEW_QUESTIONS',
  'FETCH_INTERVIEW_QUESTIONS_SUCCESS',
  'FETCH_INTERVIEW_QUESTIONS_FAIL',
];

export const addInterviewQuestionTypes = [
  'ADD_INTERVIEW_QUESTION',
  'ADD_INTERVIEW_QUESTION_SUCCESS',
  'ADD_INTERVIEW_QUESTION_FAIL',
];

export const updateInterviewQuestionTypes = [
  'UPDATE_INTERVIEW_QUESTION',
  'UPDATE_INTERVIEW_QUESTION_SUCCESS',
  'UPDATE_INTERVIEW_QUESTION_FAIL',
];

export const removeInterviewQuestionTypes = [
  'REMOVE_INTERVIEW_QUESTION',
  'REMOVE_INTERVIEW_QUESTION_SUCCESS',
  'REMOVE_INTERVIEW_QUESTION_FAIL',
];

export const saveAnswersAndRatingsTypes = [
  'SAVE_ANSWERS_AND_RATINGS',
  'SAVE_ANSWERS_AND_RATINGS_SUCCESS',
  'SAVE_ANSWERS_AND_RATINGS_FAIL',
];

export const updateApplicantStatusTypes = [
  'UPDATE_APPLICANT_STATUS',
  'UPDATE_APPLICANT_STATUS_SUCCESS',
  'UPDATE_APPLICANT_STATUS_FAIL',
];

export const CLEAR_APPLICANT_FIELDS = 'CLEAR_APPLICANT_FIELDS';



// WEBPACK FOOTER //
// ./src/modules/interviews/action_types.js